import Marionette from 'backbone.marionette';
import core_layouts from '../../../../core/layouts';
import help_pages from '../../views/Help';
import { AdvertisingView } from '../../views';
import { Winners } from '../../collections';
import '../../styles/help-page.styl';
import { Model } from 'backbone';
import { sizes_for_big_ad } from '../../../../core/utils';

export default class HelpController extends Marionette.Object {
	startFullWidth(content) {
		const
			rootView = this.getOption('rootView'),
			fullWidthLayout = new core_layouts.FullWidth(),
			advertisingFooter = new AdvertisingView({
				'ad_id': 'prizes-ad-slot-2',
				pos: 3,
			});

		fullWidthLayout.getRegion('content').show(content);
		rootView.getRegion('main').show(fullWidthLayout);
		rootView.getRegion('top_ads_container').show(advertisingFooter);
	}

	startRightSidebar(data) {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView({
				ad_id:   'prizes-ad-slot-1',
				ad_path: 'prizes',
				size:    [ 300, 250 ],
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id:   'prizes-ad-slot-2',
				ad_path: 'prizes',
				size:    sizes_for_big_ad(),
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		rightSidebarLayout.getRegion('content').show(data.content);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('top_ads_container').show(advertisingFooter);
	}

	help() {

	}

	whatsNew() {
		return this.faq();
		// const content = new help_pages.TippingWhatsNewView();
		// this.startFullWidth(content);
	}

	faq() {
		const content = new help_pages.TippingFAQsView();
		this.startFullWidth(content);
	}

	contactUs() {
		const data = {
			content: new help_pages.TippingContactUsView()
		};
		this.startRightSidebar(data);
	}

	gameGuidelines() {
		const content = new help_pages.GameGuidelinesView();
		this.startFullWidth(content);
	}

	prizes() {
		const content = new help_pages.TippingPrizesView({
			collection: new Winners(),
			model: new Model({
				winners: ''
			})
		});
		this.startFullWidth(content);
	}

	termsAndConditions() {
		const content = new help_pages.TippingTermsAndConditionsView();
		this.startFullWidth(content);
	}
}